export default {
  admin: 'Administrator',
  dev: 'Developer',
  orgAdmin: 'Org Administrator',
};
